import { DataItem } from '@/types';
import { DataItem as DataItemComp } from '@/components';
import { FC } from 'react';

import '@/components/DataItems/DataItems.scss';

interface DataItemsProps {
  items: DataItem[];
  mode?: 'light' | 'dark';
}

export const DataItems: FC<DataItemsProps> = ({ items, mode = 'light' }) => {
  return (
    <div className="data-items">
      {items.map(({ key, label, value, single, hideLabel, inline }) => (
        <DataItemComp
          key={key}
          label={label}
          value={value}
          single={single}
          hideLabel={hideLabel}
          inline={inline}
          mode={mode}
        />
      ))}
    </div>
  );
};
